module.exports = __webpack_public_path__ + "2c413d852.png";